import { render, staticRenderFns } from "./PlainTextImage.vue?vue&type=template&id=138f2795&scoped=true&"
import script from "./PlainTextImage.vue?vue&type=script&lang=js&"
export * from "./PlainTextImage.vue?vue&type=script&lang=js&"
import style0 from "./PlainTextImage.vue?vue&type=style&index=0&id=138f2795&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "138f2795",
  null
  
)

export default component.exports